module.exports = __webpack_public_path__ + "static/media/Toscana 60x120-4.4ea0ceb1.jpg";